export const LLM_INTERACTION_CATEGORIES = 'llm-interaction-categories';

export const APP_PATH = {
    BLANK: '/',
    AUTH: '/auth',
    LLM_CATEGORISATION_INTERACTIONS: '/' + LLM_INTERACTION_CATEGORIES,
};

export const AUTH_PATH = '/#/auth';